
import { HttpResponse, defaultHttpResponse } from "../auth/AuthInterface";
import { PaginacionProps } from "../global/PaginacionInterface";

import { AmparoProps, defaultAmparo } from "../recepcion/AmparoInterface";
import { ExpedienteProps, defaultExpediente } from "../recepcion/ExpedienteInterface";
import { ExhortoRecibidoProps, defaultExhortoRecibido } from "../recepcion/ExhortoRecibidoInterface";
import { IrregularProps, defaultIrregular } from "../recepcion/IrregularInterface";

// Definición de defaults

export const defaultNotificacionResponse: NuevaNotificacionResponse = { ...defaultHttpResponse, idNotificacion:''};

export const defaultNotificacion: NotificacionProps = {
    idNotificacion:             0,
    idPersonaNotificar:         0,
    personaNotificar:           '',
    idTipoParte:                0,
    tipoParte:                  '',
    idDomicilioNotificar:       0,
    domicilioNotificar:         '',
    idPlantilla:                0,
    plantilla:                  '',
    idTipoNotificacion:         0,
    tipoNotificacion:           '',
    idFormaNotificacion:        0,
    formaNotificacion:          '',
    autoridad:                  '',
    ciudad:                     '',
    idExpediente:               0,
    expediente:                 defaultExpediente,
    idAmparo:                   0,
    amparo:                     defaultAmparo,
    idExhortoRecibido:          0,
    exhortoRecibido:            defaultExhortoRecibido,
    idIrregular:                0,
    irregular:                  defaultIrregular,
    idEstatus:                  0,
    contenido:                  '',
    documento:                  '',
    contenidoAcuerdo:           '',
    acuerdo:                    '',
    tipoOficio:                 '',
    numeroBoleta:               '',
    cancelarBoleta:             false,
    cancelarNotificacion:       false,
    motivoCancelacionBoleta:    '',
    turnarCentralActuarios:     false,
    acuerdos:                   [],
    asignadoMismoUsuario:       false,
    usuarioAsignado:            '',
}

export const defaultDetalleNotificacion: DetalleNotificacionResponse = {
    ...defaultHttpResponse,
    ...defaultNotificacion,
}

export const defaultActualizarEstatus: ActualizarEstatusResponse = {
    ...defaultHttpResponse,
    usuarioAsignado:        '',
    asignadoMismoUsuario:   false,
}

export const defaultNotificacionConsulta: NotificacionConsultaResponse = {
    currentPageIndex:   0,
    pageCount:          0,
    recordsCount:       0,
    records:            [],
}

// Creación de interfaces

export interface NuevaNotificacionParams {
    idTipoNotificacion:  number,
    idFormaNotificacion: number
    idPersona:           number;
    idTipoParte:         number;
    idExpediente:        number;
    idExhortoRecibido:   number;
    idAmparo:            number;
    idIrregular:         number;
    idAcuerdo:           number;
}

export interface NuevaNotificacionResponse extends HttpResponse{
    idNotificacion:     string;
}

export interface NotificacionAcuerdoProps {
    idAcuerdo:                  number;
    tipoAcuerdo:                string;
    fecha:                      string;
    contenido:                  string;
}

export interface NotificacionArchivoProps {
    descripcion:                string;
    contenido:                  string;
    tipoArchivo:                string;
}

export interface NotificacionProps {
    idNotificacion:             number;
    idPersonaNotificar:         number;
    personaNotificar:           string;
    idTipoParte:                number;
    tipoParte:                  string;
    idDomicilioNotificar:       number;
    domicilioNotificar:         string;
    idPlantilla:                number;
    plantilla:                  string;
    idTipoNotificacion:         number;
    tipoNotificacion:           string;
    idFormaNotificacion:        number;
    formaNotificacion:          string;
    autoridad:                  string;
    ciudad:                     string;
    idExpediente:               number;
    expediente:                 ExpedienteProps;
    idAmparo:                   number;
    amparo:                     AmparoProps;
    idExhortoRecibido:          number;
    exhortoRecibido:            ExhortoRecibidoProps;
    idIrregular:                number;
    irregular:                  IrregularProps;
    idEstatus:                  number;
    contenido:                  string;
    documento:                  string;
    contenidoAcuerdo:           string;
    acuerdo:                    string;
    tipoOficio:                 string;
    numeroBoleta:               string;
    cancelarNotificacion:       boolean;
    cancelarBoleta:             boolean;
    motivoCancelacionBoleta:    string;
    turnarCentralActuarios:     boolean;
    acuerdos:                   NotificacionAcuerdoProps[];
    usuarioAsignado:            string;
    asignadoMismoUsuario:       boolean;
}

export interface GuardarNotificacionParams {
    id:                         string,
    contenido:                  string;
    idPlantilla:                number;
    idTipoNotificacion:         number;
    idFormaNotificacion:        number;
    turnarCentralActuarios:     boolean;
    cancelarBoleta:             boolean;
    motivoCancelacionBoleta:    string;
    cancelarNotificacion:       boolean;

}

export interface ActualizarEstatusParams {
    id:                         string,
    idEstatus:                  number;
    cancelarBoleta:             boolean;
    motivoCancelacionBoleta:    string;
    cancelarNotificacion:       boolean;
    turnarCentralActuarios:     boolean;

}

export interface DetalleNotificacionResponse extends HttpResponse, NotificacionProps { }

export interface ActualizarEstatusResponse extends HttpResponse{
    usuarioAsignado:            string;
    asignadoMismoUsuario:       boolean;
}

export interface NotificacionesProps {
    idNotificacion:         number;
    idTipoNotificacion:     number;
    tipoNotificacion:       string;
    idFormaNotificacion:    number;
    formaNotificacion:      string;
    idPersona:              number;
    persona:                string;
    idTipoParte:            number;
    tipoParte:              string;
    idDomicilio:            number;
    domicilio:              string;
    nuevaNotificacion?:     boolean;
}

export interface NotificacionConsultaProps {
    idNotificacion:      number;
    numeroSeguimiento:   string;
    numeroBoleta:        string;
    referencia:          string;
    personaNotificar:    string;
    tipoParte:           string;
    domicilioNotificar:  string;
    tipoNotificacion:    string;
    formaNotificacion:   string;
    idEstatus:           number;
    estatus:             string;
    usuarioAsignado:     string;
    documento:           string;
    expediente:          ExpedienteProps;
    amparo:              AmparoProps;
    exhortoRecibido:     ExhortoRecibidoProps;
    fechaOrdenamiento?:  Date;
}

export interface NotificacionConsultaParams extends PaginacionProps {
    idAutoridad:        number;
    idMateria:          number;
    numeroReferencia:   string;
    idTipoNotificacion: number;
    idUsuario:          number;
    idEstatus:          number;
    idTipoAcuerdo:      number;
    idSubTipoAcuerdo:   number;
    fecha:              string;
}

export interface NotificacionConsultaResponse {
    currentPageIndex:   number;
    pageCount:          number;
    recordsCount:       number;
    records:            NotificacionConsultaProps[];
}

export interface DescargarNotificacionesParams {
    idAutoridad:         number;
    idMateria:           number;
    numeroReferencia:    string;
    idTipoNotificacion:  number;
    idUsuario:           number;
    idEstatus:           number;
    idTipoAcuerdo:       number;
    idSubTipoAcuerdo:    number;
    fecha:               string;
}